<template>
  <div>
    <Row justify="center" type="flex" style="background: #ffffff">
      <Col span="24">
        <img
          style="width: 100%; height: 482px"
          src="../../../static/img/coreBusiness/head_img1.png"
          alt="#"
        />
        <div class="banner_font">
          <div class="banner_font1">全渠道智能一体化中台-OMS</div>
          <div class="banner_font2">
            <div>降本增效</div>
            <div style="margin: 0 0 0 1%">快速上手</div>
          </div>
        </div>
      </Col>
      <Col span="24" class="ContactUs_1"> </Col>
      <Col span="24" class="ContactUs_2"> </Col>
      <Col span="24" class="ContactUs_3"> </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.ContactUs_1 {
  height: 669px;
  background-image: url("../../../static/img/coreBusiness/bj_img4.png");
  background-size: 100% 100%;
}

.ContactUs_2 {
  height: 1075px;
  background-image: url("../../../static/img/coreBusiness/bj_img5.png");
  background-size: 100% 100%;
}

.ContactUs_3 {
  height: 729px;
  background-image: url("../../../static/img/coreBusiness/bj_img6.png");
  background-size: 100% 100%;
}

.LunContent {
  background: #ffffff;
}

.LunContent img {
  width: 100%;
  height: 900px;
}

.banner_font {
  width: 550px;
  height: 190px;
  position: absolute;
  margin: -15% 0 0 10%;
}
.banner_font1 {
  height: 37px;
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
}

.banner_font2 {
  margin-top: 2%;
  margin-left: 15%;
  font-size: 23px;
  display: flex;
  width: 550px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/coreBusiness/omsSystem.vue